export const getFollowerRange = (value: string) => {
  if (value === "nano") return "(1K-10K)";
  if (value === "micro") return "(10K-100K)";
  if (value === "macro") return "(100K-1M)";
  if (value === "celebrity") return "(1M and above)";
};
